import React from 'react';
import {DialogContent, DialogContentText, DialogTitle} from '@material-ui/core';
import { Fragment } from 'react';

interface Props {}

const ErrorModal = (title: string, description: string) => (
    <Fragment>
        <DialogTitle id="error-modal-title">{title}</DialogTitle>
        <DialogContent>
            <DialogContentText id="error-modal-description">
                {description}
            </DialogContentText>
        </DialogContent>
    </Fragment>
);

export default ErrorModal;
